module.exports = __webpack_public_path__ + "static/ccd_out-eb3d8b0ea2ad9edff5ce4a863fabd4f8.jpg";